import { Component, OnInit } from "@angular/core";
import { FieldBase, ShowField } from "src/app/shared/form-fields/model";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingStates } from "src/app/core/models/routingStates";
import { RoutingStatesService } from "src/app/core/services/routingStates.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FsplacaService } from "../../fsplaca.service";
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "src/app/core/services/common.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { DetailFsPlaca, FsplacaPK } from "../../models/fsplaca.model";

@Component({
  selector: "app-detail-fsplaca",
  templateUrl: "./detail-fsplaca.component.html",
  styleUrls: ["./detail-fsplaca.component.sass"],
})
export class DetailFsplacaComponent implements OnInit {
  public fieldsPlaca: FieldBase<any>[] = [];

  public sectionHidden = {
    placa: false,
  };

  routingStates: RoutingStates;
  routing = RoutingConstants.fsPlaca;

  public id: FsplacaPK;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routingStatesService: RoutingStatesService,
    private toastrAlertService: ToastrAlertService,
    private fsplacaService: FsplacaService,
    private translateService: TranslateService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((data) => {
      console.log("this.activatedRoute.params.subscribe", data);
      this.init();
    });
  }

  init() {
    this.routingStates = this.routingStatesService.getRoutingStates();
    this.id = this.activatedRoute.snapshot.params.id
      ? JSON.parse(this.activatedRoute.snapshot.params.id)
      : "";
    this.getQueryDetail();
  }

  getQueryDetail() {
    this.sweetAlertService.sweetAlertLoading();
    this.fsplacaService.getFsPlaca(this.id).subscribe(
      (data) => {
        this.initFields(data);
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  private initFields(data: DetailFsPlaca): void {
    this.fieldsPlaca = [
      new ShowField({
        label: "Model jahr",
        value: this.id.fsPlacmye,
      }),
      new ShowField({
        label: "Modelo",
        value: this.id.fsPlacmod,
      }),
      new ShowField({
        label: "Nro. Imagen",
        value: this.id.fsPlacimg ? this.id.fsPlacimg.substring(3) : '',
      }),
      new ShowField({
        label: "Estado",
        value: data.imEstado,
      }),
      new ShowField({
        label: "Contraseña homologación",
        value: data.imContrasenya,
      }),
      new ShowField({
        label: "Fecha vigor",
        value: data.imFvigor,
      }),
      new ShowField({
        label: "Fecha baja",
        value: data.imFbaja,
      }),
      new ShowField({
        label: "Peso máximo autorizado total sin remolque",
        value: data.imPmtaSinRemolque,
      }),
      new ShowField({
        label: "Peso máximo autorizado eje 1 sin remolque",
        value: data.imPme1SinRemolque,
      }),
      new ShowField({
        label: "Peso máximo autorizado eje 2 sin remolque",
        value: data.imPme2SinRemolque,
      }),
      new ShowField({
        label: "Peso máximo autorizado total con remolque",
        value: data.imPmtaConRemolque,
      }),
      new ShowField({
        label: "Peso máximo autorizado eje 1 con remolque",
        value: data.imPme1ConRemolque,
      }),
      new ShowField({
        label: "Peso máximo autorizado eje 2 con remolque",
        value: data.imPme2ConRemolque,
      }),
      new ShowField({
        label: "Remolcable",
        value: data.fsPesmaxre,
      }),
      new ShowField({
        label: "Contraseña GNC.",
        value: data.fsContrgnc,
      }),
      new ShowField({
        label: "Coef. absorción humos",
        value: data.imHumos,
      }),
      new ShowField({
        label: "Nivel contaminación",
        value: data.fsNivconta,
      }),
      new ShowField({
        label: "Código motor",
        value: data.imTmotor,
      }),
      new ShowField({
        label: "Pot. mot.",
        value: data.fsPotmotor ? data.fsPotmotor + " KW" : " KW",
      }),
      new ShowField({
        label: "Cil. mot.",
        value: data.fsCilindra ? data.fsCilindra + " C.C." : " C.C",
      }),
      new ShowField({
        label: "Tipo/Variante/Versión",
        value: data.imTvv,
      }),
      new ShowField({
        label: "Observaciones",
        value: data.imObservaciones,
      }),
      new ShowField({
        label: "Denomicación modelo",
        value: data.fsDenomode,
      }),
      new ShowField({
        label: "Número de plazas",
        value: data.fsNumplaza,
      }),
      new ShowField({
        label: "Fábrica",
        value: data.fsCodfabri,
      }),
    ];
  }

  goList() {
    if (this.routingStates) {
      this.router.navigate([
        this.routingStates.urlBefore,
        this.routingStates.urlBeforeId,
      ]);
    } else if (this.activatedRoute.data["_value"]["url"] == "consulta") {
      this.router.navigate([RoutingConstants.certificatesQuery.list]);
    } else {
      this.router.navigate([this.routing.list]);
    }
  }
}
